/** Ask every canvas shell to close the main Library. Creating or selecting a shader must not leave templates open on top of the prompt. */
export const CLOSE_SHADER_LIBRARY_EVENT = 'genie:close-library'

export function requestCloseShaderLibrary(): void {
  document.dispatchEvent(new CustomEvent(CLOSE_SHADER_LIBRARY_EVENT))
}

export function subscribeShaderLibraryClose(close: () => void): () => void {
  const handler = () => close()
  document.addEventListener(CLOSE_SHADER_LIBRARY_EVENT, handler)
  return () => document.removeEventListener(CLOSE_SHADER_LIBRARY_EVENT, handler)
}
